import { KeyValuePair } from '@app/core/models/keyValuePair';

class SlantProfiles {
  Straight = { key: 1, value: 'Recht' };
  Slant = { key: 2, value: 'Schuin' };
}
const slantProfiles = new SlantProfiles();
const keyValuePairs: KeyValuePair[] = [
  slantProfiles.Straight,
  slantProfiles.Slant,
];

export  {
    slantProfiles,
    keyValuePairs
}
